import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { CONST_ROOT_COMPONENT_INDEX, createSelectAllComponentsAction } from "@multiweb/picasso";
import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { createCreateTransitionAction, createDeleteSelectedWfEntitiesAction, createEnableStatusViewAction, createEnableViewerModeAction, createSetTouchedAction, createUpdateWorkflowViewAction } from "../actions";
import { LOC_ADD_SET, LOC_NEW_SET } from "../locKeys";
import { createGetOrderedSets, getSelectedSetId } from "../selectors";
import { WorkflowEditorProps } from "../types";
import { WorkflowEditorComponent, WorkflowEditorComponentProps } from "./WorkflowEditorComponent";

type StateProps = Pick<WorkflowEditorComponentProps, "sets" | "selectedSetId" | "addSetText" | "newSetText">;

const createMapStateToProps: (state: IAppState, props: WorkflowEditorProps) => MapStateToProps<StateProps, WorkflowEditorProps, IAppState> = (_state, { hostKey }) => {
    const orderedSets = createGetOrderedSets();

    return (state) => ({
        sets: orderedSets(state, hostKey),
        selectedSetId: getSelectedSetId(state, hostKey),
        addSetText: getPrimaryText(state, LOC_ADD_SET) ?? "Přidat sadu",
        newSetText: getPrimaryText(state, LOC_NEW_SET) ?? "Nová sada",
    });
};

type DispatchProps = Pick<WorkflowEditorComponentProps, "enableStatusView" | "enableViewerMode" | "updateWorkflowView" | "setTouched" | "createTransition" | "deleteSelectedWfEntities" | "selectAllWFActivities">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, WorkflowEditorProps> = (dispatch, { hostKey }) => ({
    enableStatusView: (variables) => dispatch(createEnableStatusViewAction(hostKey, variables)),
    enableViewerMode: () => dispatch(createEnableViewerModeAction(hostKey)),
    updateWorkflowView: (setId, isNonEditChange) => dispatch(createUpdateWorkflowViewAction(hostKey, setId, undefined, undefined, isNonEditChange)),
    setTouched: (touched) => dispatch(createSetTouchedAction(hostKey, touched)),
    createTransition: () => dispatch(createCreateTransitionAction(hostKey)),
    deleteSelectedWfEntities: () => dispatch(createDeleteSelectedWfEntitiesAction(hostKey)),
    selectAllWFActivities: () => dispatch(createSelectAllComponentsAction(hostKey, CONST_ROOT_COMPONENT_INDEX)),
});

export const WorkflowEditor = connect(createMapStateToProps, mapDispatchToProps)(WorkflowEditorComponent);
